import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'
import orgamax from 'ampersand-app'

import AcceptAvvForm from './AcceptAvvForm'
import { UserService } from '../../service/userService'

const AcceptAvvModal = (props) => {
  const [isLoading, setIsLoading] = useState(false)
  const { onResolve } = props
  const classes = useStyles()

  const handleConfirmClick = ({ isAccepted } = {}) => {
    if (!isAccepted) {
      console.error('avv requires to be accepted')
      return
    }

    setIsLoading(true)
    UserService
      .acceptAvv()
      .then(responseData => orgamax.user.login(responseData, { noRedirect: true }))
      .then(() => onResolve())
      .catch((error) => {
        console.error(error)
        setIsLoading(false)
      })
  }

  return (
    <div className={classes.wrapper}>
      <AcceptAvvForm
        loading={isLoading}
        onConfirm={handleConfirmClick}
      />
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  wrapper: {
    borderRadius: 4,
    height: 'auto',
    minHeight: 600,
  },
}))

export default AcceptAvvModal
